import Button from '../Button';
import ErrorMessage from '../Form/ErrorMessage';
import InputRadio, { InputRadioGroup } from '../Input/InputRadio';
import InputText from '../Input/InputText';
import { RegularAmountModifyResult } from '../Layer/RegularAmountChangeLayerPopup';
import {
  MySupportInfoControllerService,
  myActiveHistoryVo,
  myMissModuleVo,
} from '@/__generated__/FrontApi';
import PaymentMethodChange, {
  PaymethodUpdateResult,
} from '@/components/Layer/PaymentMethodChangeLayerPopup';
import { H4 } from '@/components/Titles';
import { fakeCardMask, maskNumber } from '@/helpers/AddMaskingNumbers';
import { breakpoint } from '@/helpers/BreakpointHelper';
import GtmHelper from '@/helpers/GtmHelper';
import { isMobileDevice } from '@/helpers/BrowserHelper';
import {
  getPaymentTypeLabel,
  getPaymentTypeNameToCode,
} from '@/helpers/PaymentHelper';
import {
  PAYMENT_HIGH_AMOUNT,
  PAYMENT_HIGH_AMOUNT_MSG,
  PAYMENT_MIN_AMOUNT,
  PAYMENT_MIN_AMOUNT_MSG,
  getPledgeDayOfMonth,
} from '@/helpers/SupportHelper';
import { InputRadioPledgePaymentDay } from '@/page-blocks/donate/DonateCommon';
import { usePopupStore } from '@/stores/PopupStore';
import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  &.error {
    width: 100%;
    background: #f8f9fa;
    padding: 16px;
    justify-content: center;
    text-align: center;

    .sky {
      color: #1cabe2 !important;
    }
  }
  & + & {
    margin-top: 14px;
    ${breakpoint(800)} {
      margin-top: 20px;
    }
  }

  .price_change_form {
    margin-left: auto;
  }
  .br_m {
    display: none;
    ${breakpoint(800)} {
      display: block;
    }
  }
`;
const Category = styled.div`
  height: 44px;
  line-height: 2;
  color: #828385;
  strong {
    color: #1cabe2;
    display: inline-block;
    margin-left: 40px;
    &.first {
      margin-left: 0;
    }
  }
  ${Button} {
    margin-left: 32px;
  }
  ${breakpoint(800)} {
    height: auto;
    min-height: 0;
  }
`;
const PriceDetail = styled.div`
  margin-top: 18px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0;
  span {
    position: relative;
    display: inline-block;
    padding-right: 10px;
    line-height: 1.6;
    &.is-failed {
      color: #e2231a;
    }
    & + span {
      padding-left: 10px;
      &::before {
        content: '';
        display: block;
        width: 1px;
        height: 16px;
        background: #e5e6e8;
        position: absolute;
        left: 0;
        top: 3px;
      }
    }
  }
  ${breakpoint(640)} {
    margin-top: 8px;
    span {
      font-size: 13px;
      padding-right: 6px;
      & + span {
        padding-left: 6px;
      }
    }
  }
`;
const RadioLabel = styled.div`
  display: table-cell;
  cursor: pointer;
`;
const RadioFlex = styled(InputRadioGroup)`
  border-right: 1px solid #1cabe2;
  .btn {
    border-right: none;
    transition: all 0.25s;
    background: #fff;
    &:hover {
      background: #1cabe2;
      color: #fff;
    }
  }
`;
const InputTextCustom = styled.div<{ disabled?: boolean }>`
  border: 1px solid #e5e6e8;
  margin-top: -1px;
  ${({ disabled }) => {
    if (!disabled) {
      return `
            span {
              color: #2d2926 !important;
            }
          `;
    }
    return ``;
  }}
  ${breakpoint(800)} {
    height: 48px;
    line-height: 44px;
    margin-bottom: 16px;
    input {
      height: 44px;
    }
  }
`;
const Cell = styled.div<{ type?: string; status?: string; price?: boolean }>`
  ${InputTextCustom} {
    span {
      width: 10%;
      text-align: right;
      color: #b7b8ba;
    }
  }
  ${({ type }) => {
    if (type === `total`) {
      return `
          width: 160px;
          flex-shrink: 0;
          text-align: center;
          font-weight: bold;
          font-size: 20px;
          .sky {
            color: #1cabe2
          }
          margin-left: auto;
        `;
    }
    if (type) {
      return `
            width: 160px;
            flex-shrink: 0;
            text-align: center;
            font-weight: bold;
            font-size: 20px;
            .sky {
              color: #1cabe2
            }
          `;
    }
    return `padding-left: 24px; flex: 1; min-width: 0;`;
  }}
  ${breakpoint(800)} {
    ${({ type }) => {
      if (type === `total`) {
        return `
            display: block;
            width: auto;
            text-align: right;
            position: absolute;
            top: 24px;
            right: 0;
            white-space: nowrap;
            .sky {
              font-size: 14px;
            }
          `;
      }
      if (type === `status`) {
        return `
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex: none;
            gap: 10px;
            width: 100%;
            margin-top: 16px;
            font-size: 14px;
            button {
              flex: 1;
              padding: 10px 0 !important;
              font-size: 14px !important;
              line-height: 1.4 !important;
              height: auto !important;
              max-height: none;
            }
          `;
      }
      return `
        display: block;
        padding-left: 0;
        padding-right: 90px;
        width: 100%;
        flex: none;
      `;
    }}
  }
  ${({ price }) => {
    if (price) {
      return `
            padding-right: 16px;
            ${InputText} {
              border: none;
              width: 90%;
              display: inline-block;
            }
          `;
    }
    return ``;
  }}
  ${breakpoint(800)} {
    ${({ price }) => {
      if (price) {
        return `
            padding-right: 0;
          `;
      }
      return ``;
    }}
  }
  ${({ status }) => {
    if (status === `dark`) {
      return `
            color: #2d2926
          `;
    }
    if (status === `light`) {
      return `
            color: #828385;
          `;
    }
    return ``;
  }}
  &.change_cell {
    max-width: 400px;
    ${breakpoint(800)} {
      max-width: 100%;
    }
  }
`;

interface ChangePropsData {
  pledgeList: myActiveHistoryVo[];
  pledgeInfo: myActiveHistoryVo;
  moduleInfo?: myMissModuleVo;
  onUpdateAmount: (updateInfo: RegularAmountModifyResult) => void;
  onUpdatePaymethod: (updateInfo: PaymethodUpdateResult) => void;
}
interface AmountUpdateForm {
  paymentDay: string;
  changePrice: string;
  changePriceInput?: string;
}
const CellChange = styled(Cell)<{ active?: boolean }>``;
// 선택 가능한 금액 옵션
const prices = [30000, 50000, 100000];
const MyRegularSupportPriceChange: React.FC<ChangePropsData> = observer(
  ({
    pledgeList,
    pledgeInfo,
    moduleInfo,
    onUpdateAmount,
    onUpdatePaymethod,
  }) => {
    const popupStore = usePopupStore();

    // 후원 상태 체크
    const isPaused = pledgeInfo.mandateUpdateYn === 'N';
    const isBillingInProgress = pledgeInfo.isMandateUpdate === 'true';
    const isRejected = pledgeInfo.mandateStatus === '등록 실패';
    const isDisabled = !isRejected && (isPaused || !isBillingInProgress); // Rejected는 버튼 비활성화 안함!

    // 에러 메시지 결정 (우선순위: Rejected > Paused > Billing)
    let errorMessage = null;
    let errorMessageClass = '';
    if (isRejected) {
      errorMessage = (
        <>
          결제정보 오류로 진행되지 않은 후원입니다. <br className="br_m" />
          결제정보를 변경해 주세요.
        </>
      );
      errorMessageClass = '';
    } else if (isPaused) {
      errorMessage = <>현재 후원이 일시중단 상태로 변경이 불가합니다.</>;
      errorMessageClass = 'sky'; // 파란색
    } else if (!isBillingInProgress) {
      errorMessage = <>현재 후원금 결제가 진행 중으로 변경이 불가합니다.</>;
      errorMessageClass = 'sky'; // 파란색
    }

    const [isPaymentMethodOpen, setIsPaymentMethodOpen] = useState(false);
    const {
      register,
      watch,
      handleSubmit,
      reset,
      setValue,
      formState: { errors, isSubmitting },
    } = useForm<AmountUpdateForm>(); // useEffect 로 초기값 셋팅함
    // 저장후 다시 로딩할 경우 변경된 값을 default로 셋팅할 수 있도록 처리
    useEffect(() => {
      reset({
        changePrice:
          (prices.includes(pledgeInfo.bill || 0) && String(pledgeInfo.bill)) ||
          '기타',
        changePriceInput:
          (!prices.includes(pledgeInfo.bill || 0) && String(pledgeInfo.bill)) ||
          '',
        paymentDay: pledgeInfo.payday.padStart(2, '0'),
      });
    }, [pledgeInfo, reset]);
    const [isEditMode, setIsEditMode] = useState(false);
    const changePrice = watch('changePrice');
    const changePriceInput = watch('changePriceInput');
    const finalPrice = useMemo(
      () =>
        changePrice !== '기타' ? Number(changePrice) : Number(changePriceInput),
      [changePrice, changePriceInput],
    );

    const onSubmit: SubmitHandler<AmountUpdateForm> = useCallback(
      async (formData) => {
        // 금액이 동일하면 무시하고 닫기
        if (
          pledgeInfo.bill === finalPrice &&
          pledgeInfo.payday.padStart(2, '0') === formData.paymentDay
        ) {
          setIsEditMode(false);
          return;
        }
        let updateMode = '';
        if (pledgeInfo.bill !== finalPrice) {
          updateMode = 'amount';
        }
        if (pledgeInfo.payday.padStart(2, '0') !== formData.paymentDay) {
          updateMode = updateMode ? 'both' : 'day';
        }
        // 금액 체크
        if (finalPrice < PAYMENT_MIN_AMOUNT) {
          popupStore.show(`${PAYMENT_MIN_AMOUNT_MSG}`);
          return;
        }
        if (finalPrice >= PAYMENT_HIGH_AMOUNT) {
          popupStore.show(`${PAYMENT_HIGH_AMOUNT_MSG}`);
          return;
        }
        try {
          const {
            resultCode,
            resultMessageDetail,
            data,
          } = await MySupportInfoControllerService.updatePledgeAmountUsingPost({
            amount: `${finalPrice}`,
            pledgeId: pledgeInfo.pledgeId,
            paymentDay: formData.paymentDay,
            pathType: moduleInfo ? `MISSMODULE` : `SUPPORT`,
            updateChannelDetail: isMobileDevice() ? `Mobile` : `PC`,
          });
          if (resultCode === `success`) {
            // GTM 이벤트 발생
            // const supportCategory = useFindSupportCategory(pledgeInfo?.glCode);
            GtmHelper.editPayMoney({
              supportCategory: pledgeInfo.description || '', // 세일즈포스 도입 전 전송 데이터 : supportCategory || ``,
              oldAmount: String(pledgeInfo.bill),
              newAmount: String(finalPrice),
            });
            // SF 반영 대기
            await new Promise((r) => setTimeout(r, 2000));
            onUpdateAmount({
              donationName: pledgeInfo.description || '',
              upgradeAmount: finalPrice - (pledgeInfo.bill || 0),
              originAmount: pledgeInfo.bill || 0,
              amount: finalPrice ? String(finalPrice) : '',
              nextPayDay: data?.nextPayDay || '',
              glCode: '',
              updateMode,
            });
          } else {
            popupStore.show(resultMessageDetail || `오류가 발생했습니다`);
          }
        } catch (e: any) {
          if (e.response) {
            popupStore.show(
              e.response.data.resultMessage || `오류가 발생했습니다`,
            );
          }
        }
        setIsEditMode(false);
      },
      [
        finalPrice,
        moduleInfo,
        onUpdateAmount,
        pledgeInfo.bill,
        pledgeInfo.description,
        pledgeInfo.payday,
        pledgeInfo.pledgeId,
        popupStore,
      ],
    );

    return (
      <>
        <Row>
          <Cell>
            <Category>
              <strong className="first">{`${pledgeInfo.description} ${
                pledgeInfo.cdDescriptionDetail
                  ? ` [${pledgeInfo.cdDescriptionDetail}]`
                  : ``
              }`}</strong>
            </Category>
            {!isEditMode && (
              <PriceDetail>
                {pledgeInfo.startDonateDate &&
                  dayjs(
                    pledgeInfo.startDonateDate,
                    `YYYY-MM-DD`,
                    true,
                  ).isValid() === true &&
                  pledgeInfo.startDonateDate > dayjs().format(`YYYY-MM-DD`) && (
                    <span>
                      첫 후원 예정일 :{' '}
                      {dayjs(
                        pledgeInfo.startDonateDate,
                        `YYYY-MM-DD`,
                        true,
                      ).format(`YYYY.MM.DD`)}
                    </span>
                  )}
                <span>
                  매월 {getPledgeDayOfMonth(pledgeInfo.payday || '')}일
                </span>
                {pledgeInfo.paymentType && (
                  <span>
                    <strong>
                      {getPaymentTypeLabel(pledgeInfo.paymentType || '')}
                    </strong>
                  </span>
                )}
                {pledgeInfo.paymentNumber && (
                  <span>
                    {pledgeInfo.companyName}
                    {pledgeInfo.paymentType === 'Card' && (
                      <>({fakeCardMask(pledgeInfo.paymentNumber)})</>
                    )}
                    {pledgeInfo.paymentType === 'CMS' && (
                      <>({maskNumber(pledgeInfo.paymentNumber)})</>
                    )}
                  </span>
                )}
              </PriceDetail>
            )}
          </Cell>
          {!isEditMode && (
            <CellChange type="total">
              <span className="sky">
                {Number(pledgeInfo.bill).toLocaleString()}원
              </span>
            </CellChange>
          )}
          {isEditMode ? (
            <form
              className="price_change_form"
              onSubmit={handleSubmit(onSubmit)}
              key={`frmPledgeList${pledgeInfo.pledgeId}`}
            >
              <CellChange
                price
                className="change_cell"
                key={`CellChange_${pledgeInfo.pledgeId}`}
              >
                <RadioFlex>
                  {prices.map((priceValue) => (
                    <RadioLabel
                      key={`CellChangeLabel_${pledgeInfo.pledgeId}-${priceValue}`}
                    >
                      <InputRadio
                        tab
                        ref={register}
                        label={priceValue.toLocaleString()}
                        value={priceValue.toString()}
                        name="changePrice"
                      />
                    </RadioLabel>
                  ))}
                  <RadioLabel>
                    <InputRadio
                      tab
                      ref={register}
                      label="기타"
                      value="기타"
                      name="changePrice"
                    />
                  </RadioLabel>
                </RadioFlex>
                <InputTextCustom disabled={prices.includes(finalPrice)}>
                  <InputText
                    ref={register}
                    name="changePriceInput"
                    placeholder="금액 직접 입력"
                    disabled={prices.includes(finalPrice)}
                  />
                  {` `}
                  <span>원</span>
                </InputTextCustom>
                <H4
                  css={`
                    margin: 16px 0 13px;
                  `}
                >
                  결제일
                </H4>
                <InputRadioPledgePaymentDay
                  name="paymentDay"
                  paytype={getPaymentTypeNameToCode(
                    pledgeInfo.paymentType || '',
                  )}
                  defaultDay={`${pledgeInfo.payday}`.padStart(2, '0') || ''}
                  ref={register({
                    required: {
                      value: true,
                      message: `필수 입력입니다`,
                    },
                  })}
                  readOnly={false}
                />
                {errors.paymentDay && (
                  <ErrorMessage>{errors.paymentDay.message}</ErrorMessage>
                )}
              </CellChange>
              <Cell type="status">
                <Button
                  type="submit"
                  full
                  size="sm"
                  disabled={isDisabled || isSubmitting}
                  css={`
                    width: 100% !important;
                    max-width: 160px !important;
                    ${breakpoint(991)} {
                      margin-top: 0 !important;
                    }
                    ${breakpoint(800)} {
                      max-width: 100% !important;
                    }
                  `}
                >
                  {isSubmitting ? '처리중...' : '완료'}
                </Button>
              </Cell>
            </form>
          ) : (
            <Cell type="status">
              <Button
                size="sm"
                color="gray"
                outline
                onClick={() => {
                  setIsEditMode(true);
                }}
                css={`
                  padding: 10px 0 !important;
                  width: 100% !important;
                  max-width: 160px !important;
                  margin-top: 0 !important;
                  line-height: 1.4 !important;
                  ${breakpoint(800)} {
                    max-width: none !important;
                    flex: 1;
                  }
                  ${breakpoint(640)} {
                    padding: 8px 0 !important;
                    font-size: 14px !important;
                  }
                `}
                disabled={isDisabled}
              >
                후원금 변경
              </Button>
              <Button
                size="sm"
                color="gray"
                outline
                onClick={() => setIsPaymentMethodOpen(true)}
                css={`
                  width: 100% !important;
                  max-width: 160px !important;
                  padding: 10px 0 !important;
                  margin-top: 6px;
                  line-height: 1.4 !important;
                  ${breakpoint(991)} {
                    margin-top: 6px !important;
                  }
                  ${breakpoint(800)} {
                    max-width: none !important;
                    margin-top: 0 !important;
                    flex: 1;
                  }
                  ${breakpoint(640)} {
                    padding: 8px 0 !important;
                    font-size: 14px !important;
                  }
                `}
                disabled={isDisabled}
              >
                결제정보 변경
              </Button>
            </Cell>
          )}
        </Row>
        {errorMessage && (
          <Row className="error">
            <ErrorMessage className={errorMessageClass}>
              {errorMessage}
            </ErrorMessage>
          </Row>
        )}
        {/* 결제정보 변경 팝업 */}
        {isPaymentMethodOpen && (
          <PaymentMethodChange
            isOpen={isPaymentMethodOpen}
            moduleInfo={moduleInfo}
            pledgeList={pledgeList}
            pledgeInfo={pledgeInfo}
            onRequestClose={() => {
              setIsPaymentMethodOpen(false);
            }}
            onSubmitAfter={(updateInfo: PaymethodUpdateResult) => {
              setIsPaymentMethodOpen(false);
              onUpdatePaymethod(updateInfo);
            }}
          />
        )}
      </>
    );
  },
);

export default MyRegularSupportPriceChange;
